import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { LegInfo } from '../../../src/models/vessel-performance-model';
import { PerformanceUtils } from '../../../src/utils/performance-utils';

@customElement('current-leg-info-box')
export class CurrentLegInfoBox extends LitElement {
    @property({type: Object}) data: LegInfo = PerformanceUtils.ZeroLegInfo();

    static get styles() {
        return [
            css`
            :host {
                pointer-events: none;
            }
            
            .container {
                display: flex;
                flex-direction: row;
                background: var(--performance-viewer-graph-background);
                width: 248px;
                height: 57px;
                font-family: 'MaerskText';
                text-align: left;
            }

            .block {
                width: 100%;
                display: inline-block;
                color: var(--performance-viewer-dial-text-color);
                margin-top: 15px;
                margin-left: 15px;
            }

            .toptext { 
                font-size: 10px;
                font-weight: bold;
                line-height: 12px;
            }

            .lowertext {
                font-size: 12px;
                line-height: 16px;
                font-weight: normal;
            }
        `];
    }
    
    render() {
        return html`
            <div class="nextWaypoint">
                <div class="container">
                    <div class="block">
                        <div class="toptext">ETA AT<br>NEXT WAYPOINT</div>
                        <div class="lowertext">${this._getETAString(this.data.etaBasedOnCurrentSpeed)}</div>
                    </div>
                    <div class="block">
                        <div class="toptext">DISTANCE TO<br>NEXT WAYPOINT</div>
                        <div class="lowertext">${this.data.distance.toFixed(1)} NM</div>
                    </div>
                </div>
                <div class="container">
                    <div class="block">
                        <div class="toptext">NEXT WAYPOINT DETAILS</div>
                        <div class="lowertext">${this.data.nextLegWaypointDetails}</div>
                    </div>
                </div>
            </div>
        `;
    }

    private _getETAString(date: Date | null)
    {
        const _months = ["Jan", "Feb", "Mar","Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        if (!date) {
            return '';
        }

        return _months[date.getUTCMonth()] + " " + 
               date.getUTCDate() + " " + 
               date.getUTCHours().toString().padStart(2, '0') + ":" + 
               date.getUTCMinutes().toString().padStart(2, '0') + " UTC";
    }
};
